import React from 'react';
import { Workflow } from '../../../types/workflow';

const STATUS_BG: Record<string, { bg: string; color: string }> = {
  active:       { bg: '#E9F6F6', color: '#0F6E56' },
  superseded:   { bg: '#F5F7FA', color: '#595A60' },
  'rolled-back':{ bg: '#FEE2E2', color: '#b91c1c' },
};

export function VersionsTab({ workflow }: { workflow: Workflow }) {
  return (
    <section className="bg-white border border-trim rounded-xl overflow-hidden">
      <div className="px-5 py-3 border-b border-trim flex items-center justify-between">
        <h3 className="text-sm font-semibold text-ink">Version history</h3>
        <span className="text-xs text-muted">{workflow.versions.length} versions</span>
      </div>
      <ul>
        {workflow.versions.map(v => {
          const st = STATUS_BG[v.status] || STATUS_BG.superseded;
          return (
            <li key={v.version} className="px-5 py-4 border-b border-wash last:border-0">
              <div className="flex items-center gap-3 flex-wrap">
                <span className="font-mono text-sm text-ink font-semibold">v{v.version}</span>
                <span className="px-2 py-0.5 rounded-full text-xs font-medium" style={{ background: st.bg, color: st.color }}>{v.status}</span>
                <span className="text-xs text-muted">{new Date(v.deployed_at).toLocaleString()}</span>
                <span className="text-xs text-muted ml-auto">Deployed by {v.deployed_by} · Approved by {v.approver}</span>
              </div>
              <div className="text-sm text-copy mt-2">{v.migration_notes}</div>
              <div className="mt-2">
                <div className="text-xs font-medium text-ink mb-1">Changes</div>
                <ul className="list-disc pl-5 text-sm text-copy space-y-0.5">
                  {v.changes.map((c, i) => <li key={i}>{c}</li>)}
                </ul>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
